import { ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { client, LocaleResponse } from '@/api';
import { useUserStore } from '@/store';

/**
 * Deprecated
 * Instead of it, useLocalesStore from @/store/locales has to be used
 */
export const useLocales = () => {
  const mapLocales = ref<Record<string, string>>({});

  const {
    data: locales,
    isLoading: isLocalesLoading,
    error: localesError,
  } = useQuery({
    queryKey: ['locales'],
    queryFn: () => client.games.getLocales(),
    placeholderData: [],
    select(data: LocaleResponse[]) {
      mapLocales.value = data.reduce((acc: Record<string, string>, locale: LocaleResponse) => {
        acc[locale.id] = locale.name;

        return acc;
      }, {});

      return data;
    },
  });

  const userStore = useUserStore();
  const { defaultLocaleId } = userStore;
  const selectedLocaleId = ref(defaultLocaleId);

  const selectLocale = (id: number) => {
    const locale = locales.value?.find((l) => l.id === id);

    if (locale === undefined) {
      return;
    }

    selectedLocaleId.value = locale.id;
  };

  const getLocaleName = (localeId: number): string | undefined => mapLocales.value[localeId.toString()];

  return {
    locales,
    isLocalesLoading,
    localesError,
    selectedLocaleId,
    selectLocale,
    defaultLocaleId,
    mapLocales,
    getLocaleName,
  } as const;
};
